import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";

const Star = () => (
  <svg width="120" height="24" viewBox="0 0 120 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {[0, 1, 2, 3, 4].map((i) => (
      <path
        key={i}
        d={`M${12 + i * 24} 2L${14.472 + i * 24} 9.236L${22 + i * 24} 9.236L${15.764 + i * 24} 13.528L${18.236 + i * 24} 20.764L${12 + i * 24} 16.472L${5.764 + i * 24} 20.764L${8.236 + i * 24} 13.528L${2 + i * 24} 9.236L${9.528 + i * 24} 9.236L${12 + i * 24} 2Z`}
        fill="#FFD700"
      />
    ))}
  </svg>
);

export default function Reviews() {
  const { t } = useTranslation();
  const [position, setPosition] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const testimonials = [
    { quote: t("reviews.review1.quote"), author: t("reviews.review1.author") },
    { quote: t("reviews.review2.quote"), author: t("reviews.review2.author") },
    { quote: t("reviews.review3.quote"), author: t("reviews.review3.author") },
    { quote: t("reviews.review4.quote"), author: t("reviews.review4.author") },
    { quote: t("reviews.review5.quote"), author: t("reviews.review5.author") },
    { quote: t("reviews.review6.quote"), author: t("reviews.review6.author") },
    { quote: t("reviews.review7.quote"), author: t("reviews.review7.author") },
  ];

  const infiniteTestimonials = testimonials.concat(testimonials).concat(testimonials).concat(testimonials);
  const visibleItems = 3;
  const itemCount = infiniteTestimonials.length;

  const next = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setPosition((prev) => (prev + 1) % (itemCount - visibleItems + 1));
    setTimeout(() => setIsAnimating(false), 500);
  };

  const prev = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setPosition(
      (prev) =>
        (prev - 1 + (itemCount - visibleItems + 1)) % (itemCount - visibleItems + 1)
    );
    setTimeout(() => setIsAnimating(false), 500);
  };

  return (
    <div className="w-[90%] mx-auto p-4 mt-28 sm:mt-52 sm:mb-72">
      <div className="review-head text-white text-5xl mb-4 sm:mb-8">{t("userReviews")}</div>

      <div className="w-full gap-3 mx-auto">
        <div className="flex-1 overflow-hidden">
          <div
            className="slider-container flex gap-4 transition-transform duration-500 ease-in-out"
            style={{
              transform: `translateX(${
                window.innerWidth < 768 ? -position * 100 : -position * (100 / visibleItems)
              }%)`,
              width: "100%",
            }}
          >
            {infiniteTestimonials.map((item, index) => (
              <div key={index} className="w-[95%] sm:w-[calc(100%/3.11)] flex-none box-border">
                <div className="review-box rounded-2xl grid grid-cols-1 gap-4 p-6 sm:p-12 bg-customPurple-light border border-customPurple-light h-full">
                  <div className="review-star">
                    <Star />
                  </div>
                  <p className="text-xl text-white mb-4">{item.quote}</p>
                  <div className="mt-auto">
                    <p className="font-semibold text-white">{item.author}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="icons flex gap-4 float-right m-4">
          <button
            onClick={prev}
            disabled={isAnimating}
            className="flex-none w-12 h-12 flex items-center justify-center rounded-full bg-white shadow-lg transition-all duration-300 hover:bg-gray-50 hover:scale-110 border border-gray-200"
          >
            <ChevronLeft className="w-6 h-6 text-gray-600" />
          </button>
          <button
            onClick={next}
            disabled={isAnimating}
            className="flex-none w-12 h-12 flex items-center justify-center rounded-full bg-white shadow-lg transition-all duration-300 hover:bg-gray-50 hover:scale-110 border border-gray-200"
          >
            <ChevronRight className="w-6 h-6 text-gray-600" />
          </button>
        </div>
      </div>
    </div>
  );
}
